import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5606cb8c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "member__header-holder" }, null, -1))
const _hoisted_2 = { class: "member__avatar-holder" }
const _hoisted_3 = { class: "member__name" }
const _hoisted_4 = { class: "member__function" }
const _hoisted_5 = { class: "member__review-holder member--padding" }
const _hoisted_6 = { class: "member__small-title" }
const _hoisted_7 = { class: "member__rating-holder" }
const _hoisted_8 = { class: "member__num-rating" }
const _hoisted_9 = { class: "member__msg member--padding member__desc" }
const _hoisted_10 = { class: "member--padding" }
const _hoisted_11 = { class: "member__small-title" }
const _hoisted_12 = { class: "member__location" }
const _hoisted_13 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_Rating = _resolveComponent("Rating")!
  const _component_FaIcon = _resolveComponent("FaIcon")!
  const _component_OverlayDialog = _resolveComponent("OverlayDialog")!

  return (_openBlock(), _createBlock(_component_OverlayDialog, {
    "modal-id": "member-details",
    "is-open": _ctx.isModalOpen,
    onClose: _ctx.closeDialog,
    "disable-close": _ctx.isLoading
  }, {
    header: _withCtx(() => []),
    content: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Avatar, {
          name: _ctx.member.firstName,
          "last-name": _ctx.member.lastName,
          "img-path": _ctx.member.profilePictureUrl,
          "custom-size": 132,
          "is-liked": _ctx.memberHolder.favourite,
          class: "member__avatar",
          size: "medium",
          "is-likeable": "",
          onMemberLiked: _ctx.likeMember
        }, null, 8, ["name", "last-name", "img-path", "is-liked", "onMemberLiked"]),
        _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.member.fullName), 1),
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.member.functionName), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("global.reviews")), 1),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_Rating, {
            control: _ctx.starRating,
            unit: "px",
            disabled: ""
          }, null, 8, ["control"]),
          _createElementVNode("p", _hoisted_8, "(" + _toDisplayString(_ctx.member.reviewScoreCount ? _ctx.member.reviewScoreCount : 0) + ")", 1)
        ])
      ]),
      _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t("shift_details.worked_shifts", { n: _ctx.member.numberOfCompaniesShifts })) + ", " + _toDisplayString(_ctx.$t("shift_details.at_your_company", {
            n: _ctx.member.numberOfCompaniesClientsShifts,
          })), 1),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t("global.about")), 1),
        _createElementVNode("p", _hoisted_12, [
          _createVNode(_component_FaIcon, {
            class: "mq-p-icon__location",
            icon: ['fal', 'location-dot']
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.member.city), 1)
        ]),
        _createElementVNode("p", {
          innerHTML: _ctx.member.about,
          class: _normalizeClass(["member__desc member__desc--height", {
            'member__desc--reset-clamp': _ctx.isExpandedDesc,
          }])
        }, null, 10, _hoisted_13),
        (_ctx.showReadMoreBtn)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.expandAbout && _ctx.expandAbout(...args))),
              class: "member__btn-read-more"
            }, _toDisplayString(_ctx.isExpandedDescText) + "... ", 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["is-open", "onClose", "disable-close"]))
}